import React from 'react';
import gql from 'graphql-tag';
import { LoadingIndicator } from '@storable/canaveral-components';
import compose from '../../../../src/web/utils/react/compose';
import widget from '../../../../src/web/components/widgets/decorators/widget';
import BlogPost from './BlogPost';
import { NAME, ID } from './properties';
import useQuery from '../../../../modules/react/hooks/useQuery';
import useCurrentPageData from '../../../../modules/react/hooks/useCurrentPageData';

const GET_BLOG_DATA = gql`
  query GetBlogPostData($slug: String!) {
    currentSite {
      id
      ...BlogPostBlogSettings
    }
    blogPost(slug: $slug) {
      id
      ...BlogPostBlogPost
    }
  }

  ${BlogPost.fragments.settings}
  ${BlogPost.fragments.posts}
`;

const BlogPostContainer = () => {
  const { slug: pageSlug } = useCurrentPageData();
  const slug = pageSlug.replace(/^blog\//, '');
  const { data, loading } = useQuery(GET_BLOG_DATA, { variables: { slug } });

  return loading
    ? <LoadingIndicator />
    : (
      <BlogPost
        post={data?.blogPost}
        blogSettings={data?.currentSite.blogSettings}
      />
    );
};

export default compose(
  widget(
    { name: NAME, deprecated: true, componentId: ID },
    {
      menu: false,
    },
  ),
)(BlogPostContainer);
